<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'RequestLogFileList',
  props: {
    show: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      headers: [
        { text: 'Log Type', value: 'logType', sortable: false },
        { text: 'Status Code', value: 'statusCode', sortable: false },
        { text: 'Status Message', value: 'statusTrace', sortable: false },
        { text: 'File Request', value: 'fileRequest', sortable: false },
        { text: 'File Response', value: 'fileResponse', sortable: false },
      ],
    };
  },
  computed: {
    ...mapState({
      requestLogFilesList: state => state.requestStatus.requestLogFilesList,
    }),
  },
  methods: {
    ...mapActions({
      getRequestLogFilesList: 'requestStatus/getRequestLogFilesList',
      closeRequest: 'requestStatus/closeRequest',
    }),
    getStatusChip(status) {
      let returnValue = '';
      switch (status) {
        case 0:
          returnValue = { color: 'error', label: 'error' };
          break;
        case 1:
          returnValue = { color: 'warning', label: 'warning' };
          break;
        case 2:
          returnValue = { color: 'success', label: 'success' };
          break;
        case 3:
          returnValue = { color: 'light-blue', label: 'pending' };
          break;
        default:
          returnValue = { color: 'error', label: 'error' };
      }
      return returnValue;
    },
    showFile(f) {
      if (f.file !== undefined) {
        return true;
      }
      return false;
    },
  },
  watch: {
    show() {
      this.dialog = true;
      this.getRequestLogFilesList(this.requestLogFilesList.request.id);
    },
    dialog() {
      if (!this.dialog) {
        this.closeRequest();
      }
    },
  },
};
</script>

<template>
  <v-dialog v-model="dialog" width="1000" scrollable>
    <v-flex>
      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          <span class="d-inline-block">
            Request ID -
            {{ requestLogFilesList.request.id }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="requestLogFilesList.items"
            :loading="requestLogFilesList.loading"
            class="elevation-1"
            hide-actions
          >
            <template v-slot:no-data>
              <tr>
                <td v-if="!requestLogFilesList.loading" colspan="5" class="text-xs-center">
                  No data were found for that request
                </td>
              </tr>
            </template>
            <template v-slot:items="data">
              <td>{{ data.item.logType }}</td>
              <td>
                <v-chip
                  :color="getStatusChip(data.item.statusCode).color"
                  text-color="white"
                >
                  {{ getStatusChip(data.item.statusCode).label }}
                </v-chip>
              </td>
              <td>{{ data.item.statusMessage }}</td>
              <td>
                <a
                  v-if="showFile(data.item.files[0])"
                  :href="data.item.files[0].file"
                  target="_blank"
                >
                    Open File
                </a>
              </td>
              <td>
                <a
                  v-if="showFile(data.item.files[1])"
                  :href="data.item.files[1].file"
                  target="_blank"
                >
                   Open File
                </a>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            @click="dialog = false"
            color="primary"
            flat
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/requests/RequestLogFileList.vue